import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MultifactorVerifyPageComponent as AuthMultifactorVerifyPageComponent } from '@principle-theorem/ng-auth';
import { PageSplashComponent } from '@principle-theorem/ng-principle';

@Component({
  selector: 'pr-multifactor-verify-page',
  templateUrl: './multifactor-verify-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PageSplashComponent, AuthMultifactorVerifyPageComponent],
})
export class MultifactorVerifyPageComponent {}
